import { render } from "./HomeNew.vue?vue&type=template&id=2aa8bf5a&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"

import "./HomeNew.vue?vue&type=style&index=0&id=2aa8bf5a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa8bf5a"]])

export default __exports__